import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/** ?embed=1 — 파트너 사이트 iframe·미니 위젯용 (헤더/푸터 최소화) */
export default function useEmbedMode() {
  const [params] = useSearchParams();
  return useMemo(() => {
    const v = params.get('embed');
    return v === '1' || v === 'true' || v === 'yes';
  }, [params]);
}

/**
 * 임베드 URL 생성 (다른 프로덕트·랜딩에서 링크/iframe)
 * @param {string} path — 예: `/claim/abc`, `/transfer`
 * @param {{ locale?: string }} [opts]
 */
export function buildEmbedPath(path, opts = {}) {
  const base = path.startsWith('/') ? path : `/${path}`;
  const q = new URLSearchParams({ embed: '1' });
  if (opts.locale) q.set('lang', opts.locale);
  return `${base}?${q.toString()}`;
}
